<template>
    <header>
        <div class="container">
            <div class="button-actions">
                <button @click="toggleInfoPanel(true)" aria-label="How to play">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 128c17.67 0 32 14.33 32 32c0 17.67-14.33 32-32 32S224 177.7 224 160C224 142.3 238.3 128 256 128zM296 384h-80C202.8 384 192 373.3 192 360s10.75-24 24-24h16v-64H224c-13.25 0-24-10.75-24-24S210.8 224 224 224h32c13.25 0 24 10.75 24 24v88h16c13.25 0 24 10.75 24 24S309.3 384 296 384z"/></svg>
                </button>

                <button v-if="false">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M0 190.9V185.1C0 115.2 50.52 55.58 119.4 44.1C164.1 36.51 211.4 51.37 244 84.02L256 96L267.1 84.02C300.6 51.37 347 36.51 392.6 44.1C461.5 55.58 512 115.2 512 185.1V190.9C512 232.4 494.8 272.1 464.4 300.4L283.7 469.1C276.2 476.1 266.3 480 256 480C245.7 480 235.8 476.1 228.3 469.1L47.59 300.4C17.23 272.1 .0003 232.4 .0003 190.9L0 190.9z"/></svg>
                </button>
            </div>

            <h1><span @click="toggleDebugMenuOn()">🚩</span> Flaggle</h1>

            <div class="button-actions justify-end">
                <button @click="toggleStatsPanel(true)" aria-label="View stats">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M32 32C49.67 32 64 46.33 64 64V400C64 408.8 71.16 416 80 416H480C497.7 416 512 430.3 512 448C512 465.7 497.7 480 480 480H80C35.82 480 0 444.2 0 400V64C0 46.33 14.33 32 32 32zM160 224C177.7 224 192 238.3 192 256V320C192 337.7 177.7 352 160 352C142.3 352 128 337.7 128 320V256C128 238.3 142.3 224 160 224zM288 320C288 337.7 273.7 352 256 352C238.3 352 224 337.7 224 320V160C224 142.3 238.3 128 256 128C273.7 128 288 142.3 288 160V320zM352 192C369.7 192 384 206.3 384 224V320C384 337.7 369.7 352 352 352C334.3 352 320 337.7 320 320V224C320 206.3 334.3 192 352 192zM480 320C480 337.7 465.7 352 448 352C430.3 352 416 337.7 416 320V96C416 78.33 430.3 64 448 64C465.7 64 480 78.33 480 96V320z"/></svg>
                </button>
                <button @click="shuffle()" aria-label="New game">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M424.1 287c-15.13-15.12-40.1-4.426-40.1 16.97V352H336L153.6 108.8C147.6 100.8 138.1 96 128 96H32C14.31 96 0 110.3 0 128s14.31 32 32 32h80l182.4 243.2C300.4 411.3 309.9 416 320 416h63.97v47.94c0 21.39 25.86 32.12 40.99 17l79.1-79.98c9.387-9.387 9.387-24.59 0-33.97L424.1 287zM336 160h47.97v48.03c0 21.39 25.87 32.09 40.1 16.97l79.1-79.98c9.387-9.391 9.385-24.59-.0013-33.97l-79.1-79.98c-15.13-15.12-40.99-4.391-40.99 17V96H320c-10.06 0-19.56 4.75-25.59 12.81L254 162.7L293.1 216L336 160zM112 352H32c-17.69 0-32 14.31-32 32s14.31 32 32 32h96c10.06 0 19.56-4.75 25.59-12.81l40.4-53.87L154 296L112 352z"/></svg>
                </button>
            </div>
        </div>
    </header>
</template>

<script>
    import { mapActions } from 'vuex';
    import { getTodaysLocation, generateSeedText } from '../lib/daily';

    export default {
        methods: {
            ...mapActions('UIManager', [
                'toggleInfoPanel',
                'toggleStatsPanel',
                'toggleDebugMenuOn'
            ]),

            ...mapActions('GameManager', [
                'setAnswerLocationByName',
                'setSeedText',
                'setGameMode',
                'clearAllGuesses',
                'setGiveUpGame',
            ]),

            shuffle() {
                const seedInput = Math.random().toString().slice(2);
                const seedText = generateSeedText(seedInput);
                this.setGameMode('seed');
                this.setSeedText(seedInput);
                this.setAnswerLocationByName(getTodaysLocation(seedText).name);
                this.setGiveUpGame(false);
                this.clearAllGuesses();
            },
        }
    }
</script>

<style scoped lang="scss">
    header {
        border-bottom: 3px solid grey;
        margin-bottom: 15px;
        padding: 1rem 0;

        .container {
            display: flex;
            align-items: center;
        }

        .button-actions {
            flex: 1 1 0%;
            display: flex;
            align-items: center;

            button {
                height: 33px;
                width: 33px;
                margin: 5px;
                appearance: none;
                background: none;
                color: white;
                padding: 2px;
                border: none;
                cursor: pointer;

                svg path {
                    fill: #ba8af5;
                    will-change: fill;
                    transition: fill 0.2s ease-in-out;
                }

                &:hover,
                &:focus {
                    svg path {
                        fill: #5c2aa1;
                    }
                }
            }
        }
    }

    h1 {
        color: white;
        font-size: 26px;
        line-height: 1.4;
        margin-bottom: 0;
        margin-top: 0;

        @media (min-width: 768px) {
            font-size: 30px;
        }
    }

    

    .justify-end {
        justify-content: flex-end;
    }
</style>